export class TeamLogo {
  constructor(
    private originalName: string,
    private path: string,
    private height: number,
    private width: number,
    private size: number,
    private mimeType: string,
  ) {}

  public getOriginalName(): string {
    return this.originalName;
  }

  public getHeight(): number {
    return this.height;
  }

  public getPath(): string {
    return this.path;
  }

  public setPath(param: string): void {
    this.path = param;
  }

  public getWidth(): number {
    return this.width;
  }

  public getSize(): number {
    return this.size;
  }

  public getMimeType(): string {
    return this.mimeType;
  }
}
